import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  fetchEducationWorkProgramByCourse,
  fetchEducationWorkPrograms,
  getBooksInfo
} from '../../actions/educationWorkPrograms';
import EducationWorkProgramsCard from '../../components/educationWorkPrograms/EducationWorkProgramsCard';
import { searchBooks } from '../../actions/booksRequestsTable';
import {
  fetchCourseBooks,
  deleteCourseBook,
  addCourseBook
} from '../../reducers/CourseBooks/actions';



const mapStateToProps = ({ educationWorkPrograms, booksRequest, booksInfo, courseBooksReducer }) => ({
  booksRequest: booksRequest,
  books: courseBooksReducer.list,
  loader: courseBooksReducer.isLoading,
  educationPrograms: educationWorkPrograms.educationPrograms,
  booksInfo: booksInfo,
});


const mapDispatchToProps = dispatch => ({
  fetchEducationWorkPrograms: (idcurriculum, idcourse) => dispatch(fetchEducationWorkPrograms(idcurriculum, idcourse)),
  fetchEducationWorkProgramsById: (idCurriculumCourse) => dispatch(fetchEducationWorkProgramByCourse(idCurriculumCourse)),
  fetchCourseBooks: courseId => dispatch(fetchCourseBooks(courseId)),
  deleteCourseBook: (id, course) => dispatch(deleteCourseBook(id, course)),
  searchBooks: (dataset, page) => dispatch(searchBooks(dataset, page)),
  addCourseBook: data => dispatch(addCourseBook(data)),
  getBooksInfo: booksArray => dispatch(getBooksInfo(booksArray)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(EducationWorkProgramsCard),
);
